

































import { Component, Vue } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { useWexProxyStore } from "@/admin/store/wexProxy";
import { UserPermission } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";



@Component
export default class WexDisableLegacyInvestment extends Vue {
  $validator: Validator;

  wexProxyStore = useWexProxyStore();
  rolePermissionsStore = useRolePermissionsStore();

  isLoaded = false;
  isSubmitting = false;
  file = null;

  defaultAgreements = [];

  get submitDisabled (): boolean {
  return this.isSubmitting || !this.file;
}

submit (): void {
  if (!this.file) return;
  if (this.isSubmitting) return;

  this.isSubmitting = true;

    this.wexProxyStore.processLegacyStatusesFile({
    csv: this.file
  })
    .finally(() => {
      this.isSubmitting = false;
      this.file = null;
    });
}


    get hasEditPermission (): boolean {
      return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUserManagementEdit);
  }


}
